import type { AnyAction } from 'redux';
import type { Facet, FavoriteFolder } from '@/interfaces';
import { actions } from '@/state/filterActions';
import { fetchHotels } from '@/ducks/searchResults/actions';
import { CheckboxFilter } from '@/components/checkboxFilter/CheckboxFilter';
import { useFavoriteHotelsAPI } from '@/hooks/favoriteHotelsAPI';
import useAppDispatch from '@/hooks/useAppDispatch';
import useAppSelector from '@/hooks/useAppSelector';

export const mapFavoriteFolders = (folders: readonly FavoriteFolder[] = []): readonly Facet[] =>
    [...folders]
        .sort((a, b) => b.hotelIds.length - a.hotelIds.length)
        .map((folder) => ({ value: folder.hotelIds.join(','), count: folder.hotelIds.length, displayValue: folder.folderName }));

export const FavoriteFoldersFilter = () => {
    const favoriteHotels = useFavoriteHotelsAPI();
    const dispatch = useAppDispatch();
    const checkboxValues = useAppSelector((state) => state.filters.favoriteHotels);
    return (
        <CheckboxFilter
            id="FavoriteFoldersFilter"
            label="Mine favorittlister"
            expandCollapseLabel="favorittlister"
            facetList={mapFavoriteFolders(favoriteHotels?.folders)}
            checkboxValues={checkboxValues}
            checkBoxClick={(value) => dispatch(actions.filterFavoriteHotels(value))}
            triggerFetch={() => dispatch(fetchHotels() as unknown as AnyAction)}
            hideLabel
        />
    );
};
